import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const FounderVision = () => {
  const visionPoints = [
    {
      icon: "Target",
      title: "Precision Excellence",
      description: "Every thread, every color, every design must meet the highest standards of quality and precision."
    },
    {
      icon: "Heart",
      title: "Cultural Heritage",
      description: "Preserving and celebrating India's rich textile traditions while embracing modern innovation."
    },
    {
      icon: "Users",
      title: "Partnership Approach",
      description: "Building lasting relationships with clients through trust, transparency, and collaborative success."
    },
    {
      icon: "Leaf",
      title: "Sustainable Future",
      description: "Leading the industry towards environmentally responsible manufacturing practices."
    }
  ];

  const achievements = [
    { number: "10+", label: "Years Experience" },
    { number: "1500+", label: "Happy Clients" },
    { number: "50+", label: "Team Members" },
    { number: "6+", label: "Countries Served" }
  ];

  return (
    <section className="py-8 sm:py-12 lg:py-16 xl:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 xl:gap-16 items-center">
          {/* Founder Image and Quote */}
          <div className="relative animate-fade-in order-last lg:order-first">
            {/* Achievements */}
            <div className="grid grid-cols-2 gap-3 sm:gap-4">
              {achievements?.map((achievement, index) => (
                <div key={index} className="text-center p-3 sm:p-4 lg:p-6 bg-surface rounded-lg hover:shadow-textile transition-shadow duration-300">
                  <div className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold text-textile mb-1">
                    {achievement?.number}
                  </div>
                  <div className="text-[10px] sm:text-xs lg:text-sm text-text-secondary">
                    {achievement?.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Vision Content */}
          <div className="animate-slide-up">
            <div className="flex items-center space-x-2 sm:space-x-3 mb-3 sm:mb-4 lg:mb-6">
              <div className="w-8 sm:w-10 lg:w-12 h-1 bg-textile thread-weave"></div>
              <span className="text-textile font-poppins font-medium text-xs sm:text-sm lg:text-base">Founder's Vision</span>
            </div>
            
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-poppins font-bold text-primary mb-3 sm:mb-4 lg:mb-6 leading-tight">
              Crafting Tomorrow's
              <span className="text-textile block">Textile Legacy</span>
            </h2>
            
            <p className="text-sm sm:text-base lg:text-lg xl:text-xl text-text-secondary mb-4 sm:mb-6 lg:mb-8 leading-relaxed">
              Born from a passion for textile excellence and driven by quality, Kunjvihari Impex 
              represents the perfect fusion of traditional Indian fabric craftsmanship with modern 
              manufacturing standards and premium material selection. We are specialists in position print fabric manufacturing, delivering precision and quality in every meter.
            </p>

            {/* Vision Points */}
            <div className="space-y-3 sm:space-y-4 lg:space-y-6">
              {visionPoints?.map((point, index) => (
                <div key={index} className="flex items-start space-x-2 sm:space-x-3 lg:space-x-4 group">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 bg-textile/10 rounded-full flex items-center justify-center group-hover:bg-textile group-hover:text-white transition-all duration-300 flex-shrink-0">
                    <Icon name={point?.icon} size={14} className="text-textile group-hover:text-white sm:w-[18px] sm:h-[18px] lg:w-5 lg:h-5" />
                  </div>
                  <div>
                    <h4 className="text-sm sm:text-base lg:text-lg xl:text-xl font-semibold text-primary mb-1 lg:mb-2">
                      {point?.title}
                    </h4>
                    <p className="text-xs sm:text-sm lg:text-base text-text-secondary leading-relaxed">
                      {point?.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Philosophy Quote */}
            <div className="mt-6 sm:mt-8 lg:mt-10 p-4 sm:p-5 lg:p-6 bg-gradient-heritage rounded-lg sm:rounded-xl text-white">
              <div className="flex items-start space-x-2 sm:space-x-3 lg:space-x-4">
                <Icon name="Lightbulb" size={18} className="text-golden mt-1 flex-shrink-0 sm:w-5 sm:h-5 lg:w-6 lg:h-6" />
                <div>
                  <h4 className="font-semibold mb-1.5 sm:mb-2 text-xs sm:text-sm lg:text-base">Our Philosophy</h4>
                  <p className="text-white/90 leading-relaxed text-xs sm:text-sm lg:text-base">
                    "Precision in Every Thread" isn't just our motto—it's our commitment to excellence, 
                    our respect for tradition, and our promise to every client who trusts us with their vision.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderVision;